var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 3.07272C5.3505 3.07272 3 5.48055 3 8.45077C3 11.421 5.3505 13.8288 8.25 13.8288C11.1495 13.8288 13.5 11.421 13.5 8.45077C13.5 5.48055 11.1495 3.07272 8.25 3.07272ZM1.5 8.45077C1.5 4.63192 4.52208 1.53613 8.25 1.53613C11.9779 1.53613 15 4.63192 15 8.45077C15 12.2696 11.9779 15.3654 8.25 15.3654C4.52208 15.3654 1.5 12.2696 1.5 8.45077Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.958 12.2485C12.2508 11.9484 12.7257 11.9484 13.0186 12.2485L16.2811 15.5905C16.574 15.8906 16.574 16.377 16.2811 16.6771C15.9882 16.9771 15.5133 16.9771 15.2205 16.6771L11.958 13.335C11.6651 13.035 11.6651 12.5485 11.958 12.2485Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6a2738d1d201760e93981e66630f220b.svg";
export { ForwardRef as ReactComponent };